<h1 class="text-white text-lg font-semibold mb-4">Gestión de Clientes</h1>
<div class="mb-4 flex justify-between items-center">
    <div class="flex gap-2 items-center">
        <button matButton (click)="onCreatePartner()" *ngIf="canCreatePartner$ | async">Crear Nuevo Cliente</button>
        <button matButton (click)="onSendBulkWelcomeEmails()" *ngIf="canSendWelcome$ | async">Envío masivo de Correo de Bienvenida</button>
    </div>
    <mat-form-field class="ml-4 border-0">
        <input matInput (input)="applyFilter($event)" placeholder="Buscar...">
    </mat-form-field>
</div>
<div *ngIf="dataSource.data.length === 0" class="text-center py-8 text-gray-500">
    <p>No hay clientes registrados.</p>
</div>
<div class="mat-elevation-z2">
    <table mat-table [dataSource]="dataSource" matSort class="w-full">
        <ng-container matColumnDef="email">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Correo </th>
            <td mat-cell *matCellDef="let partner" class="no-uppercase"> {{ partner.email }} </td>
        </ng-container>
        <ng-container matColumnDef="displayName">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Nombre Visible </th>
            <td mat-cell *matCellDef="let partner"> {{ partner.displayName || 'N/A' }} </td>
        </ng-container>
        <ng-container matColumnDef="disabled">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Deshabilitado </th>
            <td mat-cell *matCellDef="let partner"> {{ partner.disabled ? 'Sí' : 'No' }} </td>
        </ng-container>
        <ng-container matColumnDef="paysISR">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Paga ISR </th>
            <td mat-cell *matCellDef="let partner"> {{ partner.paysISR ? 'Sí' : 'No' }} </td>
        </ng-container>
        <ng-container matColumnDef="billingMode">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Tipo de Facturación </th>
            <td mat-cell *matCellDef="let partner"> {{ getBillingModeLabel(partner.billingMode) }} </td>
        </ng-container>
        <ng-container matColumnDef="notificationGroupingMode">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Agrupación de Facturación </th>
            <td mat-cell *matCellDef="let partner"> {{ getGroupingModeLabel(partner.notificationGroupingMode) }} </td>
        </ng-container>
        <ng-container matColumnDef="NIT">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> NIT </th>
            <td mat-cell *matCellDef="let partner"> {{ partner.NIT || 'N/A' }} </td>
        </ng-container>
        <ng-container matColumnDef="accountNumber">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Número de Cuenta </th>
            <td mat-cell *matCellDef="let partner"> {{ partner.accountNumber || 'N/A' }} </td>
        </ng-container>
        <ng-container matColumnDef="creationTime">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Creado </th>
            <td mat-cell *matCellDef="let partner">{{ partner.creationTime | date:'dd-MM-yyyy, hh:mm:ss a' }}</td>
        </ng-container>
        <ng-container matColumnDef="lastSignInTime">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Último Inicio Sesión </th>
            <td mat-cell *matCellDef="let partner">{{ partner.lastSignInTime ? (partner.lastSignInTime | date:'dd-MM-yyyy, hh:mm:ss a') : 'Nunca' }}</td>
        </ng-container>
        <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef> Acciones </th>
            <td mat-cell *matCellDef="let partner">
                <button mat-icon-button color="accent" aria-label="Editar cliente" (click)="onEditPartner(partner)" *ngIf="canEditPartner$ | async">
                    <mat-icon>edit</mat-icon>
                </button>
                <button mat-icon-button color="warn" aria-label="Eliminar cliente" (click)="onDeletePartner(partner.uid)" *ngIf="canDeletePartner$ | async">
                    <mat-icon>delete</mat-icon>
                </button>
            </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
    <mat-paginator [pageSizeOptions]="[10, 20, 50]" showFirstLastButtons aria-label="Seleccionar página de clientes"></mat-paginator>
</div>
